<script>
    export let label
    export let disabled = false
    export let busy = false
    export let active = false
</script>

<style>
    .ThinButton {
        display: inline-block;
        border-radius: 9px;
        padding: 0px 8px 1px;
        font-size: 12px;
        line-height: 14px;
        cursor: default;
        font-weight: normal;
        border: none;
        /* color: #6f899c; */
        background-color: #859db3;
        color: #fff;
        outline: none;
        /* background-color: var(--forge-action-secondary-bg);
        color: var(--forge-action-secondary-fg) */
    }
    .ThinButton:hover {
        background-color: #6f899c;
    }
    .ThinButton.busy {
        background-color: #3ad1b3;
    }
    .ThinButton.active {
        background-color: var(--forge-action-primary-bg);
        color: var(--forge-action-primary-fg)
    }
    .ThinButton .spin {
        font-size: 10px;
        margin-left: 3px;
    }
</style>

<button class="ThinButton" disabled={disabled} class:active class:busy class:disabled on:click|stopPropagation>
    <slot>{label}</slot>
    {#if busy}
        <i class="spin far fa-sync fa-spin"></i>
    {/if}
</button>